import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Breadcrumb, BreadcrumbItem, Button, Badge } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const DEMO_PARTNERS = [
  { id: '1', name: 'Gulf Payment Solutions', type: 'Payment processor', riskLevel: 'High', status: 'Compliant', lastAssessed: '2025-01-15' },
  { id: '2', name: 'Qatar Data Hosting Co.', type: 'Cloud provider', riskLevel: 'Medium', status: 'In progress', lastAssessed: '2024-12-01' },
  { id: '3', name: 'MENA Audit Services', type: 'Auditor', riskLevel: 'Low', status: 'Compliant', lastAssessed: '2025-01-20' },
  { id: '4', name: 'SecureCard Middle East', type: 'Card issuer', riskLevel: 'High', status: 'Pending', lastAssessed: '2024-10-05' },
  { id: '5', name: 'ComplianceDocs Ltd', type: 'Document management', riskLevel: 'Low', status: 'Compliant', lastAssessed: '2025-02-01' },
];

const DemoPartners: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <Breadcrumb>
        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
        <BreadcrumbItem active>Demo Partners</BreadcrumbItem>
      </Breadcrumb>
      <h2 className="mb-4">Demo Partners</h2>
      <p className="text-muted mb-4">Sample partner list (demo data only).</p>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Partner name</th>
            <th>Type</th>
            <th>Risk level</th>
            <th>Status</th>
            <th>Last assessed</th>
          </tr>
        </thead>
        <tbody>
          {DEMO_PARTNERS.map((p) => (
            <tr key={p.id}>
              <td>{p.name}</td>
              <td>{p.type}</td>
              <td>
                <Badge color={p.riskLevel === 'High' ? 'danger' : p.riskLevel === 'Medium' ? 'warning' : 'secondary'}>
                  {p.riskLevel}
                </Badge>
              </td>
              <td>
                <Badge color={p.status === 'Compliant' ? 'success' : p.status === 'In progress' ? 'info' : 'secondary'}>
                  {p.status}
                </Badge>
              </td>
              <td>{p.lastAssessed}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Button tag={Link} to="/" color="primary">
        Back to Demo Dashboard
      </Button>
    </div>
  );
};

export default DemoPartners;
